import { getOS, loadScript } from 'shared/helpers/browserHelpers';
import type {} from './botpress.d';

const isProduction = import.meta.env.VITE_TARGET === 'production';
const BOTPRESS_INJECT_URL = 'https://cdn.botpress.cloud/webchat/v3.6/inject.js';
const BOTPRESS_CONFIG_URL = isProduction
  ? 'https://files.bpcontent.cloud/2025/09/11/19/20250911191250-2YBAJIVJ.js'
  : 'https://files.bpcontent.cloud/2025/10/06/18/20251006183518-CMQYMOBR.js';

let botpressPromise: Promise<NonNullable<typeof window.botpress>> | undefined;

async function loadBotpress() {
  await loadScript({ src: BOTPRESS_INJECT_URL });
  await loadScript({ src: BOTPRESS_CONFIG_URL });

  return new Promise<NonNullable<typeof window.botpress>>((resolve) => {
    if (!window.botpress) return;
    window.botpress.on('webchat:initialized', () => {
      resolve(window.botpress as NonNullable<typeof window.botpress>);
    });
  });
}

export function getBotpress() {
  if (import.meta.env.NODE_ENV === 'test') {
    return Promise.reject(new Error('Botpress is disabled in test env'));
  }

  if (!botpressPromise) {
    botpressPromise = loadBotpress();
  }

  return botpressPromise;
}

export function resetBotpressChat() {
  if (!botpressPromise) return;

  void getBotpress().then((botpress) => {
    botpress.on('webchat:ready', async () => {
      await botpress.restartConversation();
      await botpress.updateUser({
        name: '',
        data: {
          name: '',
          email: '',
          platform: 'web_carrier_signup',
          os: getOS(),
        },
      });
    });
  });
}
